/* eslint-disable import/no-cycle */
import type React from 'react';

import * as styles from './styles';
import { useFormikContext } from 'formik';

import type { Checklist } from '@cobliteam/api-lib';

import { TrashIcon } from '@cobliteam/base-components';

import { Button } from '@cobliteam/ui/components';

import type { FormProps } from '../DrawerBody/DrawerBody';

export interface IFooterButtonsProps {
  hasLoadingRequests: boolean;
  onCancelClickButton: () => void;
  onDeleteClickButton: (checklist: Checklist) => void;
  checklist?: Checklist;
}

export const FooterButtons: React.FC<IFooterButtonsProps> = ({
  hasLoadingRequests,
  onCancelClickButton,
  onDeleteClickButton,
  checklist,
}) => {
  const { submitForm, isSubmitting, values, dirty } =
    useFormikContext<FormProps>();
  const handleOnDeleteChecklist = (target: Checklist) => () => {
    onDeleteClickButton(target);
  };

  return (
    <div
      className={
        checklist ? styles.buttonsWrapperOnEdit : styles.buttonsWrapper
      }
    >
      {checklist ? (
        <Button
          variant='text'
          color='danger'
          startIcon={<TrashIcon />}
          onClick={handleOnDeleteChecklist(checklist)}
        >
          Excluir checklist
        </Button>
      ) : null}
      <div className='flex items-center justify-end gap-10'>
        <Button variant='text' onClick={onCancelClickButton}>
          Cancelar
        </Button>

        <Button
          loading={hasLoadingRequests}
          disabled={isSubmitting || !values.checklistItems.length || !dirty}
          onClick={submitForm}
        >
          Publicar
        </Button>
      </div>
    </div>
  );
};

export default FooterButtons;
